// src/contexts/produtos/ProdutoVariacaoContext.js
import { createContext, useContext, useState, useRef } from 'react';
import { buscarProdutoVariacoes, adicionarProdutoVariacao, excluirProdutoVariacao } from '../../services/produtos/ProdutoVariacaoService';
import { useProduto } from './ProdutoContext';
const Context = createContext();
export const useProdutoVariacao = () => useContext(Context);
export const ProdutoVariacaoProvider = ({ children }) => {
  const [produtoVariacoes, setProdutoVariacoes] = useState([]);
  const produtoAtual = useRef(0);
  const { atualizarVariacoesProduto } = useProduto();
  const carregar = async produtoId => {
    produtoAtual.current = Number(produtoId || 0);
    setProdutoVariacoes([]);
    if (!produtoId) return [];
    const lista = await buscarProdutoVariacoes(produtoId);
    if (produtoAtual.current === Number(produtoId)) { setProdutoVariacoes(lista || []); atualizarVariacoesProduto(produtoId, lista || []); }
    return lista || [];
  };
  const adicionar = async item => { await adicionarProdutoVariacao(item); return carregar(item.produtoId); };
  const remover = async item => { await excluirProdutoVariacao(item.id); return carregar(item.produtoId); };
  return <Context.Provider value={{ produtoVariacoes, carregar, adicionar, remover }}>{children}</Context.Provider>;
};
